import { MsalProvider, useIsAuthenticated } from '@azure/msal-react';
import { PrimaryButton } from '@fluentui/react';
import React, { useContext } from 'react';
import { useLanguage } from '../languages';
import { AuthenticationManager } from '../security/AuthenticationManager';
import { HttpClient } from './HttpClient';
const $Context = React.createContext(null);
const EntraIdProvider = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const lang = useLanguage();
    const unAuthenticatedUserStyles = {
        "backgroundImage": "url('https://ioipcorestorageaccount.blob.core.windows.net/resources/bg/background9.png')",
        "position": "absolute",
        "left": "0",
        "right": "0",
        "top": "0",
        "border": "0",
        "height": "100%",
        "backgroundRepeat": "no-repeat",
        "backgroundSize": "cover",
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "end"
    };
    const innerStyles = {
        "height": "100%",
        "width": "300px",
        "maxWidth": "300px",
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "center",
        "background": "rgb(255 255 255 / 76%)"
    };
    return isAuthenticated
        ? React.createElement($Context.Provider, { value: props.auth }, props.children)
        : React.createElement("div", { style: unAuthenticatedUserStyles },
            React.createElement("div", { style: innerStyles },
                React.createElement(PrimaryButton, { onClick: () => props.auth.loginPopup(), text: lang.logIn, style: {
                        backgroundColor: "rgb(78 156 166)",
                        borderColor: "rgb(45 119 131)"
                    } })));
};
export const AuthenticationProvider = (props) => {
    const manager = new AuthenticationManager({
        clientId: props.clientId,
        onGetAccessToken: props.onGetAccessToken,
        onGetApimKey: props.onGetApimKey,
        onGetHeaders: props.onGetHeaders,
        tenantId: props.tenantId,
        useMsal: props.useMsal
    });
    if (props.useMsal)
        return React.createElement(MsalProvider, { instance: manager.instance },
            React.createElement(EntraIdProvider, { auth: manager }, props.children));
    return React.createElement($Context.Provider, { value: manager }, props.children);
};
export const useHttpClient = (baseUrl = '', module = '') => {
    const context = useContext($Context);
    const httpClient = new HttpClient({ baseUrl, module, auth: context });
    return httpClient;
};
